import { Expression } from './Expression.js';
export class LeftRightBasedExpression extends Expression {
    constructor(left, right) {
        super();
        this.left = left;
        this.right = right;
    }
    getLeft() {
        return this.left;
    }
    getRight() {
        return this.right;
    }
    _evaluateLeftRightExpression(visitor, localVariables) {
        const left = this.getLeft()
            .evaluate(visitor, localVariables);
        const right = this.getRight()
            .evaluate(visitor, localVariables);
        return { left, right };
    }
}
//# sourceMappingURL=LeftRightBasedExpression.js.map